export const MIN_ADDRESS_SEARCH_VALUE_LENGTH = 2;
